import Swal from "sweetalert2";
import { useStore } from "../store";
import { updateInfo } from "../info";
import { SettingContainer } from "./SettingContainer";
import { SettingTitle } from "./SettingTitle";
import { SettingText } from "./SettingText";
import { InputContainer } from "./InputContainer";
import { NumberInput } from "./NumberInput";
import { DateTimeInput } from "./DateTimeInput";
import { Button } from "./Button";

export function BroadcastTimeSettings(props) {
  const { setAnnouncement } = useStore();

  function onStartTimeSave(e, value, setDisabled) {
    updateInfo(`/broadcast/${props.broadcast.id}/startTime`, { value: value - parseInt(process.env.REACT_APP_TIMEZONE_OFFSET) }, "방송 시작 시각", () => {
      props.onSave();
      setDisabled(true);
    });
  }

  function onFinishTimeSave(e, value, setDisabled) {
    updateInfo(`/broadcast/${props.broadcast.id}/finishTime`, { value: value - parseInt(process.env.REACT_APP_TIMEZONE_OFFSET) }, "방송 종료 시각", () => {
      props.onSave();
      setDisabled(true);
    });
  }

  async function onPostponeClick(e, type) {
    const title = `방송 연기${type === "overwrite" ? " 덮어쓰기" : ""}`;
    const postpone = await Swal.fire({
      title,
      html: [
        `<span>${type === "postpone" ? "연기할 길이" : "새로운 연기 길이"}를 입력해주세요 (일/시간/분/초, 기본값: 분)</span>`,
        "<input id='swal2-duration' class='swal2-input' placeholder='30분'>"
      ].join(""),
      showCancelButton: true,
      confirmButtonText: type === "postpone" ? "연기" : "덮어쓰기",
      cancelButtonText: "취소",
      icon: "info",
      preConfirm: () => new Promise((resolve) => resolve(document.getElementById("swal2-duration").value))
    });

    if (postpone.isConfirmed) {
      const time = parseFloat(postpone.value.replace("일", "").replace("시간", "").replace("분", "").replace("초", "").replace(/ /g, ""));
      if (isNaN(time)) {
        Swal.fire({
          title: title + " 저장 실패",
          text: "시간을 입력해주세요.",
          icon: "warning",
          confirmButtonText: "확인"
        });
        return;
      }

      let unit = 1000*60; // 기본값: 분
      if (postpone.value.includes("일")) unit = 1000*60*60*24;
      else if (postpone.value.includes("시간")) unit = 1000*60*60;
      else if (postpone.value.includes("분")) unit = 1000*60;
      else if (postpone.value.includes("초")) unit = 1000;

      updateInfo(`/broadcast/${props.broadcast.id}/postpone`, { type, value: time * unit }, title, () => {
        props.onSave();
        if (type === "postpone") {
          const delayedStartTime = new Date(props.broadcast.broadcastStartTime + (time * unit) + parseInt(process.env.REACT_APP_TIMEZONE_OFFSET));

          let delayedTime = props.broadcast.delayTime + (time*unit);
          const delayedString = [];

          const day = Math.floor(delayedTime / (1000*60*60*24));
          delayedTime -= day * 1000*60*60*24;
          if (day) delayedString.push(day + "일");

          const hour = Math.floor(delayedTime / (1000*60*60));
          delayedTime -= hour * 1000*60*60;
          if (hour) delayedString.push(hour + "시간");

          const minute = Math.floor(delayedTime / (1000*60));
          delayedTime -= minute * 1000*60;
          if (minute) delayedString.push(minute + "분");

          const second = Math.floor(delayedTime / 1000);
          if (second) delayedString.push(second + "일");

          Swal.fire({
            title: "공지 등록",
            html: [
              `<span>${title}가 완료되었습니다.<br/>연기 완료 공지를 등록할까요?</span>`,
              `<input id="swal2-text" class="swal2-input" value="${props.anime.title.korean ?? props.anime.name} 애니가 ${delayedStartTime.getUTCHours()}시${delayedStartTime.getUTCMinutes() === 0 ? "" : ` ${delayedStartTime.getUTCMinutes()}분으`}로 ${delayedString.join(" ")} 연기되었습니다" placeholder="공지사항">`,
              `<input id="swal2-until" type="datetime-local" class="swal2-input" value="${delayedStartTime.toISOString().slice(0, -1)}">`
            ].join(""),
            showCancelButton: true,
            confirmButtonText: "등록",
            cancelButtonText: "아니오",
            icon: "info",
            preConfirm: () => new Promise((resolve) => resolve({
              text: document.getElementById("swal2-text").value,
              until: Date.parse(document.getElementById("swal2-until").value + "Z") - parseInt(process.env.REACT_APP_TIMEZONE_OFFSET)
            }))
          }).then(result => {
            if (result.isConfirmed) {
              updateInfo("/announcement/data", result.value, "공지사항", () => setAnnouncement(result.value));
            }
          });
        }
      });
    }
  }

  return (<>
    <SettingTitle text="방송 시간"/>

    <SettingContainer>
      <SettingText text="방송 시작"/>
      <InputContainer>
        <DateTimeInput id="broadcast-start" defaultTime={ props.broadcast.broadcastStartTime + parseInt(process.env.REACT_APP_TIMEZONE_OFFSET) } onClick={ onStartTimeSave }/>
      </InputContainer>
    </SettingContainer>

    <SettingContainer>
      <SettingText text="방송 종료"/>
      <InputContainer>
        <DateTimeInput id="broadcast-finish" defaultTime={ props.broadcast.broadcastFinishTime + parseInt(process.env.REACT_APP_TIMEZONE_OFFSET) } onClick={ onFinishTimeSave }/>
      </InputContainer>
    </SettingContainer>

    <SettingContainer>
      <SettingText text="방송 연기"/>
      <InputContainer>
        <NumberInput id="delay" unit="분" defaultValue={ props.broadcast.delayTime / 60000 } disabled/>

        <Button text="연기하기" onClick={ (e) => onPostponeClick(e, "postpone") }/>
        <Button text="덮어쓰기" onClick={ (e) => onPostponeClick(e, "overwrite") }/>
      </InputContainer>
    </SettingContainer>
  </>);
}
